import React, { useMemo, useState, useEffect, useRef} from "react";
import axios from "axios";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import pivieSurveyJson from './survey_templates/pivieSurvey.json'
import { useNavigate } from "react-router";
// Material UI
import {
  Box,
  Paper,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { service_url } from "./config";
import dayjs from "dayjs";
import { v5 as uuidv5 } from 'uuid';
import { namespace } from "./config";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);



// --- Survey JSON (shortened comment; keep your full JSON here) ---


const PivieSurveyForm = ()=>{
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const topRef = useRef(null);

  let navigate = useNavigate()

  const survey = useMemo(() => new Model(pivieSurveyJson), []);
  survey.focusFirstQuestionAutomatic = false
  
  survey.onChoicesLazyLoad.add((_, options) => {
        if (options.question.getType() === "tagbox" && options.question.name === "case_procedure") {
                const url = service_url + '/get_paginated_codes?' + `skip=${options.skip}&take=${options.take}&filter=${options.filter}&code=cpt`
                axios.get(url).then((response) => {
                    options.setItems(response.data.codes, response.data.total);
                });
        }
    });
    useEffect(() => {
      const preventNumberWheelChange = (e) => {
        const el = document.activeElement;
        if (el && el.tagName === "INPUT" && el.type === "number") {
          // blur stops the native wheel step
          el.blur();
          e.preventDefault();
        }
      };

      // capture + passive:false guarantees preventDefault works
      document.addEventListener("wheel", preventNumberWheelChange, {
        passive: false,
        capture: true,
      });

      return () => {
        document.removeEventListener("wheel", preventNumberWheelChange, {
          capture: true,
        });
      };
    }, []);

  // Attach onComplete handler once
  useEffect(() => {
    const handler = async (sender) => {
      const results = sender.data;

      setSubmitting(true);
      setSubmitError(null);
      setSubmitSuccess(false);
      console.log(results)
      let user_id = sessionStorage.getItem('user_name')
      let submission_timestamp = dayjs().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss')
      try {
        const response = await axios.post(
          service_url+'/send_pivie_data',
          {"UserName": user_id,
            "payload": results,
            "SubmitDateTime": dayjs().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss'),
            "SubmissionID": uuidv5("pivie_data_"+user_id+"_"+submission_timestamp,namespace)
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Server response:", response.data);
        setSubmitSuccess(true);
        navigate('/')
        
      } catch (error) {
        console.error("Submission error:", error);  
        setSubmitError(error?.message || "An unknown error occurred.");
      } finally {
        setSubmitting(false);
      }
    };

    
    const scrollToTop = () => {
        // wait for the next page to paint
        // window.scrollTo({
        //     top: 0,
        //     behavior: "smooth",
        // });
        setTimeout(()=>{
            window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 50)
        
    };

    survey.onComplete.add(handler);
    survey.onCurrentPageChanged.add(scrollToTop);
    
    return () => {
      survey.onComplete.remove(handler);
      survey.onCurrentPageChanged.remove(scrollToTop);
    };
  }, [survey]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center ", // left-align container
        px: 2,
        py: 4,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          minWidth: 1200,
          width: "100%",
          p: 3,
          textAlign: "left", // ensure text is left aligned
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom>
        </Typography>

        {/* SurveyJS form */}
        <Survey model={survey} />

        {/* Status area */}
        <Box mt={3} display="flex" flexDirection="column" gap={2}>
          {submitting && (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={20} />
              <Typography variant="body2">
                Sending data to server…
              </Typography>
            </Box>
          )}

          {submitSuccess && (
            <Alert severity="success">
              Data submitted successfully.
            </Alert>
          )}

          {submitError && (
            <Alert severity="error">
              Submission failed: {submitError}
            </Alert>
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default PivieSurveyForm;
